<template>

    <div :class="cssSideBarStyle">

        <SidebarElement v-for="(element,idx) in menuContents"
                        :key = 'idx'
                        :element = "element"
                        @on-expand-element = "showSubmenu"
                        @on-jump-to-submenu = "focusSubmenu"
                        :isMenuExpanded = isMenuExpanded
                        :ismobile = ismobile
        />
        <template v-if="showExtraMenu">
            <SidebarElement v-for="(element,idx) in extraMenu"
                            :key = 'idx'
                            :element = "element"
                            @on-expand-element = "showSubmenu"
                            @on-jump-to-submenu = "focusSubmenu"
                            :isMenuExpanded = "isMenuExpanded"
                            :ismobile = "ismobile"
            />
        </template>      
    </div>
  <template v-if="isSidebarVisible">
  </template>
</template>

<script>
    import SidebarElement from './SidebarElement.vue'
    // import axios from 'axios';
    import { onMounted } from 'vue'
// import { json } from 'body-parser'
    export default {
        name: 'SidebarMain',
        props: ['isMenuExpanded','ismobile','ismobileexpanded',"showExtraMenu"],
        data:function(){
            return {
                menuContents:[],
                extraMenu:[]
            }
        },
      setup(){
        onMounted(() => {

        })
      },
      computed:{
        isSidebarVisible:function(){
          if(!this.ismobile){
              return true;
            }else if(this.ismobileexpanded){
              return true;
            }else{
              return false;
            }
          },
          cssSideBarStyle:function(){
            if(!this.ismobile){
              return 'sidebar-narrow';
            }else if(this.ismobileexpanded){
              return 'sidebar-narrow';
            }else{
              return 'sidebar-narrow hide';
            }
          }
      },
      mounted () {
        console.log(window.menusidebar)
        let canonicalUrl = '';
        if (Object.prototype.hasOwnProperty.call(window, 'canonicalUrl'));{
          canonicalUrl = window.canonicalUrl;
        }
        if (Object.prototype.hasOwnProperty.call(window, 'extraSidebarMenu'));{
          this.extraMenu = window.extraSidebarMenu;
        }
        // let basePath = '';
        // if({}.hasOwnProperty.call(window,'rootPath')){
        //   basePath = window.rootPath;
        // }
        // axios.get(basePath+'assets/js/'+window.menuVersion+'.json').then(response => {
        //   console.log('response')
        //   console.log(response)
        //   let menu = response.data;
        //   for(let menuElement in menu){
        //     let isActive = false;
        //     for(let linkIdx in menu[menuElement].expand){
        //       menu[menuElement].expand[linkIdx].isActive = false;
        //       if(canonicalUrl === menu[menuElement].expand[linkIdx].url){
        //         menu[menuElement].expand[linkIdx].isActive = true;
        //         isActive = true;
        //         console.log(menu[menuElement].expand[linkIdx])
        //       }
        //       // console.log(menu[menuElement].expand)
        //     }
        //     menu[menuElement].isActive = isActive;
        //     menu[menuElement].idx = menuElement;
        //   }
        //   this.menuContents = menu;
        // })

          let menu = JSON.parse(window.sidebar);
         // alert(JSON.stringify(menu));
          for(let menuElement in menu){
            let isActive = false;
            for(let linkIdx in menu[menuElement].expand){
              menu[menuElement].expand[linkIdx].isActive = false;
              if(canonicalUrl === menu[menuElement].expand[linkIdx].url){
                menu[menuElement].expand[linkIdx].isActive = true;
                isActive = true;
                console.log(menu[menuElement].expand[linkIdx])
              }
              // console.log(menu[menuElement].expand)
            }
            menu[menuElement].isActive = isActive;
            menu[menuElement].idx = menuElement;
          }
          this.menuContents = menu;

      },
      components: {
          SidebarElement
      },
      methods: {
          showSubmenu: function(payload){
              this.$emit('on-expand',payload);
          },
          focusSubmenu: function (payload){
             this.$emit('on-focus-submenu',payload);
          }
      }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .sidebar-narrow{
        z-index:2201;
        position:relative;
        background-color:#313A41;
        width:77px;
        height:100%;
        border-right:1px solid #272E34;
        transform: translateX(0px);
        transition: 0.5s;
        overflow-y:auto;
        overflow-x:hidden;
    }
    .sidebar-narrow.hide{
      transform: translateX(-79px);
    }

</style>
